import { render, staticRenderFns } from "./ExpansionPanelHeader.vue?vue&type=template&id=5dd7c28f"
import script from "./ExpansionPanelHeader.vue?vue&type=script&lang=js"
export * from "./ExpansionPanelHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VExpansionPanelHeader,VIcon})
